function levenshteinDistance(s1: string, s2: string): number {
    const lenS1 = s1.length;
    const lenS2 = s2.length;

    const dp: number[][] = Array.from({ length: lenS1 + 1 }, () => Array(lenS2 + 1).fill(0));

    for (let i = 0; i <= lenS1; i++) {
        dp[i][0] = i;
    }
    for (let j = 0; j <= lenS2; j++) {
        dp[0][j] = j;
    }

    for (let i = 1; i <= lenS1; i++) {
        for (let j = 1; j <= lenS2; j++) {
            const cost = s1[i - 1] === s2[j - 1] ? 0 : 1;
            dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
        }
    }

    return dp[lenS1][lenS2];
}

export function levenshteinSimilarity(s1: string, s2: string): number {
    const maxLength = Math.max(s1.length, s2.length);
    if (maxLength === 0) return 100;

    const distance = levenshteinDistance(s1, s2);
    return Math.round((1 - distance / maxLength) * 100);
}
